import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addToOrganizationsUpdated: {
		id: 'servicedesk-customers-organization-common.add-customers-dialog.form.fields.organizations-select-field.add-to-organizations-updated',
		defaultMessage: 'Add customers to organization',
		description: 'Label for add to organisation field updated',
	},
});
